// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import RelayMotionController from "./relay_motion_controller"
application.register("relay-motion", RelayMotionController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AdminShellController from "./admin_shell_controller"
application.register("admin-shell", AdminShellController)

import AdminRoleController from "./admin_role_controller"
application.register("admin-role", AdminRoleController)

import ColourInputController from "./colour_input_controller"
application.register("colour-input", ColourInputController)

import WidgetPaddingController from "./widget_padding_controller"
application.register("widget-padding", WidgetPaddingController)

import HeaderFieldsController from "./header_fields_controller"
application.register("header-fields", HeaderFieldsController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import UploadBatchLiveController from "./upload_batch_live_controller"
application.register("upload-batch-live", UploadBatchLiveController)

import ConversationScrollController from "./conversation_scroll_controller"
application.register("conversation-scroll", ConversationScrollController)

import OverflowMenuController from "./overflow_menu_controller"
application.register("overflow-menu", OverflowMenuController)

import TenantDeleteController from "./tenant_delete_controller"
application.register("tenant-delete", TenantDeleteController)
